function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_95",
  "data-name": "Path 95",
  d: "M279.267,121.707l-.576-4.083A191.606,191.606,0,0,0,234.28,19.538a27.423,27.423,0,0,0-34.519-5.868L125.343,56.755A19.66,19.66,0,0,1,93.653,75.1L23.12,115.936A26.3,26.3,0,0,0,10,138.691v64.935a19.665,19.665,0,0,1,0,39.329v3.287a26.3,26.3,0,0,0,26.3,26.3h158.65a19.664,19.664,0,1,1,39.327,0h18.957a26.3,26.3,0,0,0,26.3-26.3V125.375A26.279,26.279,0,0,0,279.267,121.707Zm0,0",
  transform: "translate(-4.522 -4.515)",
  fill: "#b4b4b4"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_38",
  "data-name": "Group 38",
  transform: "translate(47.527 37.757)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_96",
  "data-name": "Path 96",
  d: "M302.493,203.963a21.913,21.913,0,1,1-21.913-21.913A21.914,21.914,0,0,1,302.493,203.963Zm0,0",
  transform: "translate(-164.493 -120.077)",
  fill: "#929292"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_97",
  "data-name": "Path 97",
  d: "M223.536,383.128a19.665,19.665,0,1,1-19.664-19.664A19.665,19.665,0,0,1,223.536,383.128Zm0,0",
  transform: "translate(-130.823 -202.11)",
  fill: "#929292"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_98",
  "data-name": "Path 98",
  d: "M403.539,342.423A13.639,13.639,0,1,1,389.9,328.785,13.639,13.639,0,0,1,403.539,342.423Zm0,0",
  transform: "translate(-217.668 -186.429)",
  fill: "#929292"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_99",
  "data-name": "Path 99",
  d: "M111.688,289.391a12.465,12.465,0,1,1-12.465-12.465A12.465,12.465,0,0,1,111.688,289.391Zm0,0",
  transform: "translate(-86.758 -162.978)",
  fill: "#929292"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_100",
  "data-name": "Path 100",
  d: "M385.715,81.614a12.692,12.692,0,1,1-12.692-12.692A12.692,12.692,0,0,1,385.715,81.614Zm0,0",
  transform: "translate(-210.464 -68.922)",
  fill: "#929292"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_101",
  "data-name": "Path 101",
  d: "M199.351,353.465a25.143,25.143,0,1,0,25.142,25.142A25.172,25.172,0,0,0,199.351,353.465Zm0,39.329a14.186,14.186,0,1,1,14.185-14.187A14.2,14.2,0,0,1,199.351,392.794Zm0,0",
  transform: "translate(-78.774 -159.832)",
  fill: "#b4b4b4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_102",
  "data-name": "Path 102",
  d: "M385.38,318.785A19.116,19.116,0,1,0,404.5,337.9,19.138,19.138,0,0,0,385.38,318.785Zm0,27.277a8.16,8.16,0,1,1,8.159-8.162A8.171,8.171,0,0,1,385.38,346.062Zm0,0",
  transform: "translate(-165.619 -144.15)",
  fill: "#b4b4b4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_103",
  "data-name": "Path 103",
  d: "M94.7,266.922a17.944,17.944,0,1,0,17.943,17.945A17.964,17.964,0,0,0,94.7,266.922Zm0,24.932a6.987,6.987,0,1,1,6.987-6.987A6.994,6.994,0,0,1,94.7,291.854Zm0,0",
  transform: "translate(-34.709 -120.698)",
  fill: "#b4b4b4"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "Path_104",
  "data-name": "Path 104",
  d: "M368.5,95.262a18.17,18.17,0,1,0-18.17-18.17A18.19,18.19,0,0,0,368.5,95.262Zm0-25.383a7.214,7.214,0,1,1-7.214,7.214A7.221,7.221,0,0,1,368.5,69.878Zm0,0",
  transform: "translate(-158.415 -26.643)",
  fill: "#b4b4b4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_105",
  "data-name": "Path 105",
  d: "M280.17,116.427l-.576-4.081a196.191,196.191,0,0,0-45.687-100.9A32.928,32.928,0,0,0,192.5,4.412L118.077,47.5a5.481,5.481,0,0,0-2.673,5.564A14.182,14.182,0,0,1,92.551,66.3a5.476,5.476,0,0,0-6.163-.46L15.854,106.68a31.741,31.741,0,0,0-11.2,10.969A5.447,5.447,0,0,0,3,120.733a31.7,31.7,0,0,0-3,13.443v64.935a5.478,5.478,0,0,0,5.478,5.478,14.186,14.186,0,0,1,0,28.373A5.478,5.478,0,0,0,0,238.44v3.287A31.81,31.81,0,0,0,31.773,273.5h158.65a5.478,5.478,0,0,0,5.478-5.478,14.185,14.185,0,1,1,28.371,0,5.478,5.478,0,0,0,5.478,5.478h18.957a31.81,31.81,0,0,0,31.773-31.773V120.859A31.981,31.981,0,0,0,280.17,116.427ZM248.707,262.544H234.629a25.147,25.147,0,0,0-49.085,0H31.773A20.843,20.843,0,0,1,11.016,243.3a25.145,25.145,0,0,0-.06-49.068V134.175a20.716,20.716,0,0,1,1.25-7.055H49.487a5.478,5.478,0,1,0,0-10.956H21.339s0,0,0,0L88.913,77.042a25.14,25.14,0,0,0,37.609-21.773l71.464-41.375a21.966,21.966,0,0,1,27.622,4.7,185.235,185.235,0,0,1,43.138,95.275l.323,2.292H148.121a16.459,16.459,0,0,1,15.493-10.956,5.478,5.478,0,1,0,0-10.956,27.437,27.437,0,0,0-26.841,21.913H96.963a5.478,5.478,0,1,0,0,10.956h39.811a27.394,27.394,0,0,0,53.679,0h79.071V241.727A20.841,20.841,0,0,1,248.707,262.544Zm-69.6-135.423a16.431,16.431,0,0,1-30.984,0Zm0,0",
  transform: "translate(0 0.001)",
  fill: "#929292"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "Path_106",
  "data-name": "Path 106",
  d: "M130.478,212.051a5.48,5.48,0,1,0,3.873,1.6A5.522,5.522,0,0,0,130.478,212.051Zm0,0",
  transform: "translate(-56.523 -95.886)",
  fill: "#b4b4b4"
});

function SvgCheese(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cheese",
    xmlns: "http://www.w3.org/2000/svg",
    width: 280.48,
    height: 273.5,
    viewBox: "0 0 280.48 273.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheese);
export default __webpack_public_path__ + "static/media/cheese.6bd53bf6.svg";
export { ForwardRef as ReactComponent };